module.exports = __webpack_public_path__ + "img/pdf.6cfd7b39.png";